import { createCachedSelector, path, defaultKeySelector } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { symbolMappingFilterStoreSelector } from '../symbolMappingFilter.selector';

export const selectedSymbolMappingFilterSelector = createCachedSelector(
  [
    path(symbolMappingFilterStoreSelector).filter(),
  ],
  (selectedFilter) => {
    return selectedFilter;
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
